import { render, staticRenderFns } from "./PayPalCard.vue?vue&type=template&id=0218d82d&scoped=true"
import script from "./PayPalCard.vue?vue&type=script&lang=js"
export * from "./PayPalCard.vue?vue&type=script&lang=js"
import style0 from "./PayPalCard.vue?vue&type=style&index=0&id=0218d82d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0218d82d",
  null
  
)

export default component.exports